'use client';

import { Label, Select } from 'components';
import { timezones } from 'constants/timezones';
import { useTranslations } from 'next-intl';
import { useClientAccountUpdate } from 'providers/UserProvider/useClientAccountUpdate';
import { useCurrentUser } from 'providers/UserProvider/useCurrentUser';
import { Option } from 'types/Option';

const TimezonePage = () => {
  const t = useTranslations();
  const { data, refetch } = useCurrentUser();
  const { mutateAsync } = useClientAccountUpdate();

  const handlerUpdateTimezone = ({ value }: Option) => {
    const timeZone = value as string;
    if (data?.emailPreferences)
      mutateAsync({
        firstName: String(data?.firstName),
        lastName: String(data?.lastName),
        locale: String(data?.locale),
        timeZone,
        emailNotifications: data?.emailPreferences
      }).then(() => refetch());
  };

  const selectedTimezone = timezones.find(([, timeZone]) => timeZone === data?.timeZone)?.at(1);

  return (
    <div className="w-full">
      <Label>{t('account_details.index.timezone')}</Label>
      <Select
        selectedValue={selectedTimezone}
        onChange={handlerUpdateTimezone}
        options={timezones.map(([time, timeZone]) => ({
          value: timeZone,
          label: `${time} ${timeZone}`
        }))}
      />
    </div>
  );
};

export default TimezonePage;
